











import Vue, { PropType } from 'vue';
import ApparatLogoWhite from '@/assets/images/ApparatLogoWhite.svg';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import SanitySimpleBlockContent from '@/models/sanitySchema/sanitySimpleBlockContent';

export default Vue.extend({
  name: 'SplashPanel',
  components: {
    ApparatLogoWhite,
    SanityBlockContent,
  },
  props: {
    content: {
      type: Array as PropType<Array<SanitySimpleBlockContent>>,
      required: true,
    },
  },
});
